<div class="placeholder-back"></div>

<div class="help">

    <!-- <ng-container *ngIf="screenType=='desktop'; else notMobile">
        <div class="circle-bg circle-bg-left"></div>
        <div class="circle-bg circle-bg-right"></div>
    </ng-container>
    <ng-template #notMobile>
        <div class="gradient-bg"></div>
    </ng-template> -->

    <div class="help-header center-content">
        <p class="help-title">华瀚帮助中心</p>
        <!-- <div class="help-tab flex">
            <div class="help-tab-item">
                <div class="software-logo software-c-logo"></div>
                <p>青华</p>
            </div>
            <mat-divider [vertical]="true"></mat-divider>
            <div class="help-tab-item">
                <div class="software-logo software-m-logo"></div>
                <p>丹书</p>
            </div>
            <mat-divider [vertical]="true"></mat-divider>
            <div class="help-tab-item">
                <div class="software-logo software-y-logo"></div>
                <p>丰芒</p>
            </div>
            <mat-divider [vertical]="true"></mat-divider>
            <div class="help-tab-item">
                <div class="software-logo software-k-logo"></div>
                <p>玄玉</p>
            </div>
        </div> -->
    </div>

    <div class="help-video center-content">
        <mat-toolbar class="video-toolbar">
            <span>青华 RIP</span>
            <span *ngIf="screenType=='desktop'">-</span>
            <span>极速、舒适、强大的现代RIP工具</span>
        </mat-toolbar>

        <div class="video-area">
            <div class="video-card">
                <div class="video-wrapper">
                    <img *ngIf="!isPlaying" class="cover-image" src="../../assets/images/porcelain/video-poster.png"
                        alt="封面图片" />
                    <video #videoPlayer controls [hidden]="!isPlaying">
                        <source src="../../assets/videos/porcelain/advertise.mp4" type="video/mp4">
                        你的浏览器不支持视频标签。
                    </video>
                    <button class="play-button" *ngIf="!isPlaying" (click)="playVideo()">
                        <img src="../../assets/images/porcelain/triangle.svg" alt="Play Icon" class="play-icon" />
                    </button>
                </div>
            </div>

            <div class="video-content">
                <img src="../../assets/images/video-content.svg" alt="">
                <div class="video-content-text">
                    <p>了解青华</p>
                    <p>在现代印刷行业中，高效、精确的排版和色彩管理对于确保最终印刷质量至关重要。而青华（Porcelain）正是为了解决这一需求而设计的，它将排版、图像处理和色彩管理整合到一个统一的平台中，极大地提升了工作流程的效率和精确度。
                    </p>
                </div>
            </div>
        </div>


    </div>

    <div class="guidance center-content">
        <mat-toolbar>
            <span>用户指南</span>
            <span class="example-spacer"></span>
            <button mat-icon-button (click)="navigateToLink(guidanceWebsitePrefix)">
                <mat-icon>arrow_forward</mat-icon>
            </button>
        </mat-toolbar>
        <div class="guidance-area">

            <ng-container *ngFor="let guidanceItem of guidanceItemList;">
                <div class="guidance-item">
                    <div class="guidance-item-logo" [ngClass]="guidanceItem.iconClass"></div>
                    <div class="guidance-item-text">
                        <a>{{guidanceItem.title}}</a>
                        <ng-container *ngIf="screenType=='desktop';else pageCount">
                            <ng-container *ngFor="let subTitle of guidanceItem.subTitle;">
                                <a
                                    (click)="navigateToLink(guidanceWebsitePrefix+guidanceItem.link+subTitle.link)">{{subTitle.title}}</a>
                            </ng-container>
                        </ng-container>
                        <ng-template #pageCount>
                            <p>{{guidanceItem.subTitle.length}}篇</p>
                        </ng-template>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="problem flex">
        <div class="problem-nav-area flex-1">
            <p>可能遇到的问题</p>
            <p>没有相同的问题？点击下面按钮查看所有问题。</p>
            <button mat-raised-button (click)="navigateToLink(problemListLink)">查看所有问题</button>
        </div>
        <div class="flex-1 problem-panel-area">
            <app-expansion-panel>
                <div panel-title>排版方式该怎么选择？</div>
                <div panel-content>
                    建议先根据订单类型和出图目标来选择排版方式。规则排版适合尺寸统一、数量明确的任务，操作简单、出图稳定；混合排版适合多规格混排场景，能兼顾效率与材料利用率；异形或高节材要求的任务更适合自动优化排版，由系统计算更紧凑的摆放方案。若您不确定该选哪一种，可以先用默认参数试排一次，再根据用料率和出图速度做微调。
                </div>
            </app-expansion-panel>
            <app-expansion-panel>
                <div panel-title>基础版和专业版有什么区别？</div>
                <div panel-content>
                    基础版适合日常打印与基础排版需求，包含常用的作业提交、输出和基础参数设置功能；专业版在此基础上提供更完整的生产能力，例如更灵活的排版策略、色彩管理能力、批量处理效率和更适合复杂订单的高级设置。如果您的工作以标准化订单为主，基础版通常已经足够；如果经常处理多规格、多材质或高频批量任务，专业版会更合适。
                </div>
            </app-expansion-panel>
            <app-expansion-panel>
                <div panel-title>青华RIP排版软件的优势是什么？</div>
                <div panel-content>
                    青华 RIP 的核心优势在于把排版、图像处理、色彩控制和输出管理放在同一套工作流里完成。您可以在同一个界面中完成文件检查、版面调整、颜色校正和任务输出，减少在多个软件之间来回切换的时间。对于广告打印、T 恤印花和高频生产场景，这种一体化流程能明显降低操作成本，也更容易保持最终输出的一致性。
                </div>
            </app-expansion-panel>
            <app-expansion-panel>
                <div panel-title>支持哪些文件格式？默认输出格式是什么？</div>
                <div panel-content>
                    常见的生产文件一般可以通过 PDF 作为主要输入格式进行处理，因为它在版面、字体和图像保真方面更稳定，也更适合跨设备传递。对于实际输出格式，系统会根据设备驱动、任务参数和当前流程自动生成对应的生产数据。建议在提交正式任务前，先确认当前设备支持的输入格式与输出配置，避免因字体缺失、透明效果或分辨率设置不一致影响结果。
                </div>
            </app-expansion-panel>
            <app-expansion-panel>
                <div panel-title>如何成为专业版用户？</div>
                <div panel-content>
                    如果您希望升级为专业版，建议先联系销售或技术支持确认当前账号、设备环境和业务需求。沟通完成后，平台会根据您的版本状态和授权方式安排开通或升级。升级前您可以先整理好当前使用场景，例如设备型号、日均任务量以及是否需要高级排版或色彩功能，这样可以更快确认适合的版本方案。
                </div>
            </app-expansion-panel>
        </div>
    </div>

</div>
